import { Component, HostBinding, OnInit } from "@angular/core";
import { FieldConfig } from "app/genericForm/field.interface";
@Component({
  selector: "app-spinner",
  template: `
  <app-cargando [id]="field.id" [tipo]="'spinner'" [ancho]="'40px'" [alto]="'40px'"></app-cargando>
`,
  styles: []
})
export class SpinnerComponent implements OnInit {
  field: FieldConfig;
  @HostBinding('class') class = '';
  constructor() {
  }
  ngOnInit() {
  }
}
